<div class="top-bar-menu" id="topMenu">
  <nav class="navbar navbar-expand-sm bg-dark navbar-dark" *ngIf="userIsLogged()" style="float:right;padding:0px">
    <span class="level-selector-drop" placement="bottom" [ngbTooltip]="'LANG_SLIDER_TOOLTIP' | translate">
    <mat-form-field style="width:100px;margin-right:15px;">
      <mat-select [(value)]="statesService.stateLanguage" (selectionChange)="setLang($event)">
        <mat-option *ngFor="let lang of ['fr','en','jp']" [value]="lang">
          {{lang | uppercase}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    </span>
    <span class="menu-sep"></span>


    <a class="user-menu nav-link account" routerLink="/my-account"
       routerLinkActive="active" placement="bottom"
       [ngbTooltip]="'MY_ACCOUNT_LINK_TOOLTIP' | translate"
       *ngIf="authenticationService.userHasRoleOsmos()">{{'MY_ACCOUNT' | translate}} {{user.firstname}}
      {{user.lastname}}</a>


    <fa-icon *ngIf="authenticationService.userHasRoleClientButRoleOsmos()" [icon]="iconService.faUser"
             class="user-icon"></fa-icon>
    <span *ngIf="authenticationService.userHasRoleClientButRoleOsmos()"
          class="user-menu nav-link account" style="color: yellowgreen">  {{user.firstname}}
      {{user.lastname}}   <br/><span style="color: #cccccc">{{user.email}}</span></span>
    <span class="menu-sep"></span>
    <span class="level-selector-drop" placement="bottom" [ngbTooltip]="'LEVELS_SELECT_TOOLTIP' | translate">

                <mat-form-field>
                  <app-progressbar *ngIf="showSpinner"></app-progressbar>
                  <mat-select [(value)]="statesService.stateLevel" (selectionChange)="selectLevel($event)">
                    <mat-option *ngFor="let level of levelsDropList" [value]="level.id">
                      {{level.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

        </span>
    <span class="menu-sep" style="margin-right:0px;margin-left:20px;"></span>
    <span class="log-out" placement="left" [ngbTooltip]="'LOG_OUT_TOOLTIP' | translate">
                <fa-icon [icon]="iconService.faSignOutAlt" (click)="authenticationService.logout()"></fa-icon>
        </span>
  </nav>
  <nav class="navbar navbar-expand-sm bg-dark navbar-dark" style="float:left">
    <a class="navbar-brand"><img src="../assets/images/logo-osmos-project-manager.png"
                                 style="width:130px"/>
    </a>
    <a *ngIf="!opmMode()" class="navbar-brand"><img src="../assets/images/logo-safeworks.png" [ngClass]="userIsLogged() ? 'logo-safe-big' :'logo-safe'"/>
    </a>
    <a
      *ngIf="userIsLogged() && authenticationService.currentUserCanManageLevels() && authenticationService.userHasRoleOsmos()"
      class="nav-link" routerLink="/levels" routerLinkActive="active" placement="bottom"
      [ngbTooltip]="'LEVELS_LINK_TOOLTIP' | translate" [innerHTML]="'LEVELS' | translate">Levels</a>
    <a
      *ngIf="userIsLogged() && authenticationService.userHasRoleOsmos() && authenticationService.currentUserCanManageUsers()"
      class="nav-link" routerLink="/users"
      routerLinkActive="active" placement="bottom"
      [ngbTooltip]="'USERS_LINK_TOOLTIP' | translate" [innerHTML]="'USERS' | translate">Users</a>

    <a *ngIf="userIsLogged()" class="nav-link" routerLink="/projects"
       routerLinkActive="active" placement="bottom"
       [ngbTooltip]="'PROJECTS_LINK_TOOLTIP' | translate" [innerHTML]="'PROJECTS' | translate">Projects</a>

    <a *ngIf="userIsLogged() && authenticationService.userHasRoleOsmosOrProduction()" class="nav-link"
       routerLink="/devices"
       routerLinkActive="active" placement="bottom"
       [ngbTooltip]="'DEVICES_LINK_TOOLTIP' | translate" [innerHTML]="'DEVICES' | translate">Devices</a>

    <a *ngIf="userIsLogged() && authenticationService.userHasRoleOsmos()"
       class="nav-link" routerLink="/projects-specials-behaviors"
       routerLinkActive="active"
       placement="bottom"
       [ngbTooltip]="'SUBSCRIPTIONS_BEHAVIOR_LINK_TOOLTIP' | translate"
       [innerHTML]="'SUBSCRIPTIONS_BEHAVIOR' | translate"></a>

    <a
      *ngIf="userIsLogged() && authenticationService.userHasRoleOsmos() && authenticationService.userHasRoleAlarmValidator()"
      class="nav-link" routerLink="/projects-alarms-validator"
      routerLinkActive="active"
      placement="bottom"
      [ngbTooltip]="'PROJECTS_ALARMS_VALIDATOR_TOOLTIP' | translate"
      [innerHTML]="'PROJECTS_ALARMS_VALIDATOR' | translate"></a>

    <a *ngIf="userIsLogged() && authenticationService.userHasRoleOsmos()"
       class="nav-link" routerLink="/dashboard/edas"
       routerLinkActive="active"
       placement="bottom"
       [ngbTooltip]="'EDAS_DASHBOARD_LINK_TOOLTIP' | translate"
       [innerHTML]="'EDAS_DASHBOARD' | translate"></a>
    <a *ngIf="userIsLogged() && authenticationService.userHasRoleOsmos()"
       class="nav-link" [routerLink]="'/manual-'+ getLang()"
       routerLinkActive="active"
       placement="bottom"
       [ngbTooltip]="'OMP_MANUAL_TOOLTIP' | translate"
       [innerHTML]="'OMP_MANUAL'|translate"></a>
  </nav>

  <br clear="both"/>

</div>
<router-outlet></router-outlet>
<div class="footer" id="footer">
  <fa-icon [icon]="iconService.faCopyright"></fa-icon>&nbsp;&nbsp;OSMOS {{date | date:'yyyy'}}
</div>
